module.exports = __webpack_public_path__ + "img/Man-1.de6051f8.svg";